import { render, staticRenderFns } from "./card-item-wrapper.vue?vue&type=template&id=08d7b88a&scoped=true"
import script from "./card-item-wrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./card-item-wrapper.vue?vue&type=script&setup=true&lang=js"
import style0 from "./card-item-wrapper.vue?vue&type=style&index=0&id=08d7b88a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7b88a",
  null
  
)

export default component.exports